var map = {
	"./arrows/bullet-blue": 102,
	"./arrows/bullet-blue.svg": 102,
	"./arrows/bullet-cyan": 103,
	"./arrows/bullet-cyan.svg": 103,
	"./arrows/bullet-green": 104,
	"./arrows/bullet-green.svg": 104,
	"./arrows/bullet-orange": 105,
	"./arrows/bullet-orange.svg": 105,
	"./arrows/bullet-white": 106,
	"./arrows/bullet-white.svg": 106,
	"./arrows/cyan-right": 107,
	"./arrows/cyan-right.svg": 107,
	"./arrows/down": 108,
	"./arrows/down-cyan": 109,
	"./arrows/down-cyan.svg": 109,
	"./arrows/down-orange": 110,
	"./arrows/down-orange.svg": 110,
	"./arrows/down.svg": 108,
	"./arrows/green-right": 111,
	"./arrows/green-right.svg": 111,
	"./arrows/orange-right": 112,
	"./arrows/orange-right.svg": 112,
	"./arrows/tail-spin": 113,
	"./arrows/tail-spin.svg": 113,
	"./arrows/twisted/cyan": 114,
	"./arrows/twisted/cyan.svg": 114,
	"./arrows/twisted/green-down": 115,
	"./arrows/twisted/green-down-left": 116,
	"./arrows/twisted/green-down-left.svg": 116,
	"./arrows/twisted/green-down.svg": 115,
	"./arrows/twisted/green-left": 117,
	"./arrows/twisted/green-left.svg": 117,
	"./arrows/twisted/green-left2": 118,
	"./arrows/twisted/green-left2.svg": 118,
	"./arrows/twisted/green-right": 119,
	"./arrows/twisted/green-right.svg": 119,
	"./arrows/twisted/light-green": 120,
	"./arrows/twisted/light-green.svg": 120,
	"./arrows/twisted/orange-3": 121,
	"./arrows/twisted/orange-3.svg": 121,
	"./arrows/twisted/orange-down": 122,
	"./arrows/twisted/orange-down.svg": 122,
	"./arrows/twisted/orange-left": 123,
	"./arrows/twisted/orange-left.svg": 123,
	"./arrows/twisted/orange-left2": 124,
	"./arrows/twisted/orange-left2.svg": 124,
	"./arrows/twisted/orange-right": 125,
	"./arrows/twisted/orange-right-long": 126,
	"./arrows/twisted/orange-right-long.svg": 126,
	"./arrows/twisted/orange-right.svg": 125,
	"./arrows/twisted/orange-right2": 127,
	"./arrows/twisted/orange-right2.svg": 127,
	"./arrows/twisted/orange-vertical": 128,
	"./arrows/twisted/orange-vertical.svg": 128,
	"./arrows/twisted/seledyn-down": 129,
	"./arrows/twisted/seledyn-down.svg": 129,
	"./arrows/twisted/seledyn-left": 130,
	"./arrows/twisted/seledyn-left.svg": 130,
	"./bg/blank-cyan": 131,
	"./bg/blank-cyan.svg": 131,
	"./bg/blank-green": 132,
	"./bg/blank-green.svg": 132,
	"./bg/blank-orange": 133,
	"./bg/blank-orange.svg": 133,
	"./bg/footer": 134,
	"./bg/footer.svg": 134,
	"./bg/hero/bialoleka-pricing": 135,
	"./bg/hero/bialoleka-pricing.webp": 135,
	"./bg/hero/bialoleka-school": 136,
	"./bg/hero/bialoleka-school.png": 136,
	"./bg/hero/brodno-pricing": 8,
	"./bg/hero/brodno-pricing.jpg": 8,
	"./bg/hero/brodno-pricing.webp": 445,
	"./bg/hero/brodno-school": 137,
	"./bg/hero/brodno-school.jpg": 137,
	"./bg/hero/camps": 138,
	"./bg/hero/camps.webp": 138,
	"./bg/hero/saska-pricing": 9,
	"./bg/hero/saska-pricing.jpg": 9,
	"./bg/hero/saska-pricing.webp": 446,
	"./bg/hero/saska-school": 139,
	"./bg/hero/saska-school.jpg": 139,
	"./bg/hex-slices-light-green": 140,
	"./bg/hex-slices-light-green.svg": 140,
	"./bg/hex-slices-seledyn": 141,
	"./bg/hex-slices-seledyn.svg": 141,
	"./bg/honeycombs": 142,
	"./bg/honeycombs-green": 143,
	"./bg/honeycombs-green.svg": 143,
	"./bg/honeycombs.svg": 142,
	"./bg/octagon": 144,
	"./bg/octagon.svg": 144,
	"./bg/shapes/career/grass": 145,
	"./bg/shapes/career/grass.svg": 145,
	"./bg/shapes/career/green": 146,
	"./bg/shapes/career/green.svg": 146,
	"./bg/shapes/career/orange": 147,
	"./bg/shapes/career/orange.svg": 147,
	"./bg/shapes/career/seledyn": 148,
	"./bg/shapes/career/seledyn.svg": 148,
	"./bg/shapes/hex-2-green": 149,
	"./bg/shapes/hex-2-green.svg": 149,
	"./bg/shapes/hex-2-orange": 150,
	"./bg/shapes/hex-2-orange.svg": 150,
	"./bg/shapes/hex-4": 151,
	"./bg/shapes/hex-4.svg": 151,
	"./bg/shapes/hex-big-cyan": 152,
	"./bg/shapes/hex-big-cyan.svg": 152,
	"./bg/shapes/hex-big-gray-light": 153,
	"./bg/shapes/hex-big-gray-light.svg": 153,
	"./bg/shapes/hex-big-green": 154,
	"./bg/shapes/hex-big-green.svg": 154,
	"./bg/shapes/hex-big-light-green": 155,
	"./bg/shapes/hex-big-light-green.svg": 155,
	"./bg/shapes/hex-big-light-orange": 156,
	"./bg/shapes/hex-big-light-orange.svg": 156,
	"./bg/shapes/hex-big-orange": 157,
	"./bg/shapes/hex-big-orange.svg": 157,
	"./bg/shapes/hex-empty": 158,
	"./bg/shapes/hex-empty.svg": 158,
	"./bg/shapes/hex-green": 159,
	"./bg/shapes/hex-green-light": 160,
	"./bg/shapes/hex-green-light.svg": 160,
	"./bg/shapes/hex-green.svg": 159,
	"./bg/shapes/hex-light": 161,
	"./bg/shapes/hex-light.svg": 161,
	"./bg/shapes/hex-orange": 162,
	"./bg/shapes/hex-orange.svg": 162,
	"./bg/shapes/hex-white": 163,
	"./bg/shapes/hex-white.svg": 163,
	"./bg/shapes/hexagon": 164,
	"./bg/shapes/hexagon.svg": 164,
	"./bg/shapes/hexagons": 165,
	"./bg/shapes/hexagons.svg": 165,
	"./bg/skip-button": 166,
	"./bg/skip-button.png": 166,
	"./icons/brandenburg_gate": 167,
	"./icons/brandenburg_gate.svg": 167,
	"./icons/cake": 168,
	"./icons/cake.svg": 168,
	"./icons/cathedral": 169,
	"./icons/cathedral.svg": 169,
	"./icons/chat": 170,
	"./icons/chat.svg": 170,
	"./icons/check-circle": 171,
	"./icons/check-circle.svg": 171,
	"./icons/check-green": 172,
	"./icons/check-green.svg": 172,
	"./icons/church": 173,
	"./icons/church.svg": 173,
	"./icons/close": 174,
	"./icons/close-white": 175,
	"./icons/close-white.svg": 175,
	"./icons/close.svg": 174,
	"./icons/cookies": 176,
	"./icons/cookies.svg": 176,
	"./icons/cross": 177,
	"./icons/cross.svg": 177,
	"./icons/download": 178,
	"./icons/download.svg": 178,
	"./icons/eiffla": 179,
	"./icons/eiffla.svg": 179,
	"./icons/eye": 180,
	"./icons/eye.svg": 180,
	"./icons/fast-msg": 181,
	"./icons/fast-msg.svg": 181,
	"./icons/fb": 182,
	"./icons/fb-color": 183,
	"./icons/fb-color.svg": 183,
	"./icons/fb.svg": 182,
	"./icons/google": 184,
	"./icons/google-color": 185,
	"./icons/google-color.svg": 185,
	"./icons/google.svg": 184,
	"./icons/grey_arrow": 186,
	"./icons/grey_arrow.svg": 186,
	"./icons/group": 187,
	"./icons/group-green": 188,
	"./icons/group-green.svg": 188,
	"./icons/group.svg": 187,
	"./icons/hut": 189,
	"./icons/hut.svg": 189,
	"./icons/instagram": 190,
	"./icons/instagram.svg": 190,
	"./icons/linkedin": 191,
	"./icons/linkedin.svg": 191,
	"./icons/marker": 192,
	"./icons/marker.png": 192,
	"./icons/next-white": 193,
	"./icons/next-white.svg": 193,
	"./icons/orange_arrow": 194,
	"./icons/orange_arrow.svg": 194,
	"./icons/party": 195,
	"./icons/party-2": 196,
	"./icons/party-2.svg": 196,
	"./icons/party.svg": 195,
	"./icons/person-heart": 197,
	"./icons/person-heart.svg": 197,
	"./icons/phone": 198,
	"./icons/phone.svg": 198,
	"./icons/pin": 199,
	"./icons/pin.svg": 199,
	"./icons/play": 200,
	"./icons/play.svg": 200,
	"./icons/prev-white": 201,
	"./icons/prev-white.svg": 201,
	"./icons/quote": 202,
	"./icons/quote.svg": 202,
	"./icons/shield": 203,
	"./icons/shield.svg": 203,
	"./icons/star": 204,
	"./icons/star.svg": 204,
	"./icons/talk": 205,
	"./icons/talk-blue": 206,
	"./icons/talk-blue.svg": 206,
	"./icons/talk.svg": 205,
	"./icons/tower": 207,
	"./icons/tower.svg": 207,
	"./icons/twitter": 208,
	"./icons/twitter.svg": 208,
	"./icons/white_arrow": 209,
	"./icons/white_arrow.svg": 209,
	"./logo": 210,
	"./logo.svg": 210,
	"./og-bialoleka": 211,
	"./og-bialoleka.jpg": 211,
	"./og-brodno": 212,
	"./og-brodno.jpg": 212,
	"./og-pygmalion": 213,
	"./og-pygmalion.jpg": 213,
	"./og-saska-kepa": 214,
	"./og-saska-kepa.jpg": 214,
	"./pic/adventure": 215,
	"./pic/adventure-green": 216,
	"./pic/adventure-green.svg": 216,
	"./pic/adventure.svg": 215,
	"./pic/bialoleka/adults": 217,
	"./pic/bialoleka/adults.webp": 217,
	"./pic/bialoleka/cambridge": 218,
	"./pic/bialoleka/cambridge.svg": 218,
	"./pic/bialoleka/hero": 219,
	"./pic/bialoleka/hero-adults": 10,
	"./pic/bialoleka/hero-adults.png": 10,
	"./pic/bialoleka/hero-adults.webp": 447,
	"./pic/bialoleka/hero-contact": 11,
	"./pic/bialoleka/hero-contact.png": 11,
	"./pic/bialoleka/hero-contact.webp": 448,
	"./pic/bialoleka/hero-exam": 12,
	"./pic/bialoleka/hero-exam.png": 12,
	"./pic/bialoleka/hero-exam.webp": 449,
	"./pic/bialoleka/hero-how-we-teach": 13,
	"./pic/bialoleka/hero-how-we-teach.png": 13,
	"./pic/bialoleka/hero-how-we-teach.webp": 450,
	"./pic/bialoleka/hero-individual": 220,
	"./pic/bialoleka/hero-individual.webp": 220,
	"./pic/bialoleka/hero-kids": 221,
	"./pic/bialoleka/hero-kids.webp": 221,
	"./pic/bialoleka/hero-old": 222,
	"./pic/bialoleka/hero-old.png": 222,
	"./pic/bialoleka/hero-teenagers": 223,
	"./pic/bialoleka/hero-teenagers.webp": 223,
	"./pic/bialoleka/hero.png": 219,
	"./pic/bialoleka/join-us": 224,
	"./pic/bialoleka/join-us.png": 224,
	"./pic/bialoleka/kayak": 225,
	"./pic/bialoleka/kayak.png": 225,
	"./pic/bialoleka/kids": 226,
	"./pic/bialoleka/kids.webp": 226,
	"./pic/bialoleka/news": 14,
	"./pic/bialoleka/news.png": 14,
	"./pic/bialoleka/news.webp": 451,
	"./pic/bialoleka/online-lessons": 227,
	"./pic/bialoleka/online-lessons.svg": 227,
	"./pic/bialoleka/picaro": 15,
	"./pic/bialoleka/picaro.png": 15,
	"./pic/bialoleka/picaro.webp": 452,
	"./pic/bialoleka/team-hero": 228,
	"./pic/bialoleka/team-hero.png": 228,
	"./pic/bialoleka/team/teachers/edyta": 229,
	"./pic/bialoleka/team/teachers/edyta.webp": 229,
	"./pic/bialoleka/team/teachers/jacek-czlonkowski": 230,
	"./pic/bialoleka/team/teachers/jacek-czlonkowski.webp": 230,
	"./pic/bialoleka/team/teachers/karolina": 231,
	"./pic/bialoleka/team/teachers/karolina.webp": 231,
	"./pic/bialoleka/team/teachers/maja": 232,
	"./pic/bialoleka/team/teachers/maja.webp": 232,
	"./pic/bialoleka/team/teachers/olha": 233,
	"./pic/bialoleka/team/teachers/olha.webp": 233,
	"./pic/bialoleka/team/teachers/rafal": 234,
	"./pic/bialoleka/team/teachers/rafal.webp": 234,
	"./pic/bialoleka/team/teachers/rodrigo": 235,
	"./pic/bialoleka/team/teachers/rodrigo.webp": 235,
	"./pic/bialoleka/team/teachers/weronika-piwowarska": 236,
	"./pic/bialoleka/team/teachers/weronika-piwowarska.webp": 236,
	"./pic/bialoleka/teenagers": 237,
	"./pic/bialoleka/teenagers.webp": 237,
	"./pic/blank": 238,
	"./pic/blank.svg": 238,
	"./pic/brodno-contact-choice": 239,
	"./pic/brodno-contact-choice.svg": 239,
	"./pic/brodno/brodno_adults": 240,
	"./pic/brodno/brodno_adults.svg": 240,
	"./pic/brodno/brodno_headmaster": 241,
	"./pic/brodno/brodno_headmaster.svg": 241,
	"./pic/brodno/brodno_kids": 242,
	"./pic/brodno/brodno_kids.svg": 242,
	"./pic/brodno/brodno_news": 243,
	"./pic/brodno/brodno_news.svg": 243,
	"./pic/brodno/brodno_teenagers": 244,
	"./pic/brodno/brodno_teenagers.svg": 244,
	"./pic/brodno/cambridge": 16,
	"./pic/brodno/cambridge-logo": 245,
	"./pic/brodno/cambridge-logo.svg": 245,
	"./pic/brodno/cambridge-prepare": 246,
	"./pic/brodno/cambridge-prepare.png": 246,
	"./pic/brodno/cambridge-prepare2": 247,
	"./pic/brodno/cambridge-prepare2.png": 247,
	"./pic/brodno/cambridge.png": 16,
	"./pic/brodno/cambridge.svg": 453,
	"./pic/brodno/cambridge_bg": 248,
	"./pic/brodno/cambridge_bg.png": 248,
	"./pic/brodno/clancity-prepare": 249,
	"./pic/brodno/clancity-prepare.png": 249,
	"./pic/brodno/exam": 17,
	"./pic/brodno/exam.jpg": 454,
	"./pic/brodno/exam.svg": 17,
	"./pic/brodno/flying-girl": 250,
	"./pic/brodno/flying-girl.svg": 250,
	"./pic/brodno/gabriel-neely": 251,
	"./pic/brodno/gabriel-neely.png": 251,
	"./pic/brodno/gallery/2020/pygmalion/big/2": 252,
	"./pic/brodno/gallery/2020/pygmalion/big/2.webp": 252,
	"./pic/brodno/gallery/2020/pygmalion/big/3": 253,
	"./pic/brodno/gallery/2020/pygmalion/big/3.webp": 253,
	"./pic/brodno/gallery/2020/pygmalion/big/4": 254,
	"./pic/brodno/gallery/2020/pygmalion/big/4.webp": 254,
	"./pic/brodno/gallery/2020/pygmalion/big/6": 255,
	"./pic/brodno/gallery/2020/pygmalion/big/6.webp": 255,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/2": 256,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/2.webp": 256,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/3": 257,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/3.webp": 257,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/4": 258,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/4.webp": 258,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/6": 259,
	"./pic/brodno/gallery/2020/pygmalion/thumbs/6.webp": 259,
	"./pic/brodno/gallery/2021/eko-piknik/big/1": 260,
	"./pic/brodno/gallery/2021/eko-piknik/big/1.webp": 260,
	"./pic/brodno/gallery/2021/eko-piknik/big/2": 261,
	"./pic/brodno/gallery/2021/eko-piknik/big/2.webp": 261,
	"./pic/brodno/gallery/2021/eko-piknik/big/3": 262,
	"./pic/brodno/gallery/2021/eko-piknik/big/3.webp": 262,
	"./pic/brodno/gallery/2021/eko-piknik/big/4": 263,
	"./pic/brodno/gallery/2021/eko-piknik/big/4.webp": 263,
	"./pic/brodno/gallery/2021/eko-piknik/big/5": 264,
	"./pic/brodno/gallery/2021/eko-piknik/big/5.webp": 264,
	"./pic/brodno/gallery/2021/eko-piknik/big/6": 265,
	"./pic/brodno/gallery/2021/eko-piknik/big/6.webp": 265,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/1": 266,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/1.webp": 266,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/2": 267,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/2.webp": 267,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/3": 268,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/3.webp": 268,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/4": 269,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/4.webp": 269,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/5": 270,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/5.webp": 270,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/6": 271,
	"./pic/brodno/gallery/2021/eko-piknik/thumbs/6.webp": 271,
	"./pic/brodno/gallery/2021/otwarcie/big/1": 272,
	"./pic/brodno/gallery/2021/otwarcie/big/1.webp": 272,
	"./pic/brodno/gallery/2021/otwarcie/big/2": 273,
	"./pic/brodno/gallery/2021/otwarcie/big/2.webp": 273,
	"./pic/brodno/gallery/2021/otwarcie/big/3": 274,
	"./pic/brodno/gallery/2021/otwarcie/big/3.webp": 274,
	"./pic/brodno/gallery/2021/otwarcie/big/4": 275,
	"./pic/brodno/gallery/2021/otwarcie/big/4.webp": 275,
	"./pic/brodno/gallery/2021/otwarcie/big/5": 276,
	"./pic/brodno/gallery/2021/otwarcie/big/5.webp": 276,
	"./pic/brodno/gallery/2021/otwarcie/big/6": 277,
	"./pic/brodno/gallery/2021/otwarcie/big/6.webp": 277,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/1": 278,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/1.webp": 278,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/2": 279,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/2.webp": 279,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/3": 280,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/3.webp": 280,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/4": 281,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/4.webp": 281,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/5": 282,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/5.webp": 282,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/6": 283,
	"./pic/brodno/gallery/2021/otwarcie/thumbs/6.webp": 283,
	"./pic/brodno/gallery/2021/polkolonie/big/1": 284,
	"./pic/brodno/gallery/2021/polkolonie/big/1.webp": 284,
	"./pic/brodno/gallery/2021/polkolonie/big/2": 285,
	"./pic/brodno/gallery/2021/polkolonie/big/2.webp": 285,
	"./pic/brodno/gallery/2021/polkolonie/big/3": 286,
	"./pic/brodno/gallery/2021/polkolonie/big/3.webp": 286,
	"./pic/brodno/gallery/2021/polkolonie/big/4": 287,
	"./pic/brodno/gallery/2021/polkolonie/big/4.webp": 287,
	"./pic/brodno/gallery/2021/polkolonie/big/5": 288,
	"./pic/brodno/gallery/2021/polkolonie/big/5.webp": 288,
	"./pic/brodno/gallery/2021/polkolonie/big/6": 289,
	"./pic/brodno/gallery/2021/polkolonie/big/6.webp": 289,
	"./pic/brodno/gallery/2021/polkolonie/big/7": 290,
	"./pic/brodno/gallery/2021/polkolonie/big/7.webp": 290,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/1": 291,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/1.webp": 291,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/2": 292,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/2.webp": 292,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/3": 293,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/3.webp": 293,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/4": 294,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/4.webp": 294,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/5": 295,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/5.webp": 295,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/6": 296,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/6.webp": 296,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/7": 297,
	"./pic/brodno/gallery/2021/polkolonie/thumbs/7.webp": 297,
	"./pic/brodno/gallery/2021/wigilia/big/1": 298,
	"./pic/brodno/gallery/2021/wigilia/big/1.webp": 298,
	"./pic/brodno/gallery/2021/wigilia/big/42": 299,
	"./pic/brodno/gallery/2021/wigilia/big/42.webp": 299,
	"./pic/brodno/gallery/2021/wigilia/big/46": 300,
	"./pic/brodno/gallery/2021/wigilia/big/46.webp": 300,
	"./pic/brodno/gallery/2021/wigilia/big/5": 301,
	"./pic/brodno/gallery/2021/wigilia/big/5.webp": 301,
	"./pic/brodno/gallery/2021/wigilia/big/58": 302,
	"./pic/brodno/gallery/2021/wigilia/big/58.webp": 302,
	"./pic/brodno/gallery/2021/wigilia/big/59": 303,
	"./pic/brodno/gallery/2021/wigilia/big/59.webp": 303,
	"./pic/brodno/gallery/2021/wigilia/thumbs/1": 304,
	"./pic/brodno/gallery/2021/wigilia/thumbs/1.webp": 304,
	"./pic/brodno/gallery/2021/wigilia/thumbs/42": 305,
	"./pic/brodno/gallery/2021/wigilia/thumbs/42.webp": 305,
	"./pic/brodno/gallery/2021/wigilia/thumbs/46": 306,
	"./pic/brodno/gallery/2021/wigilia/thumbs/46.webp": 306,
	"./pic/brodno/gallery/2021/wigilia/thumbs/5": 307,
	"./pic/brodno/gallery/2021/wigilia/thumbs/5.webp": 307,
	"./pic/brodno/gallery/2021/wigilia/thumbs/58": 308,
	"./pic/brodno/gallery/2021/wigilia/thumbs/58.webp": 308,
	"./pic/brodno/gallery/2021/wigilia/thumbs/59": 309,
	"./pic/brodno/gallery/2021/wigilia/thumbs/59.webp": 309,
	"./pic/brodno/gallery/2022/polkolonie/big/1": 310,
	"./pic/brodno/gallery/2022/polkolonie/big/1.webp": 310,
	"./pic/brodno/gallery/2022/polkolonie/big/12": 311,
	"./pic/brodno/gallery/2022/polkolonie/big/12.webp": 311,
	"./pic/brodno/gallery/2022/polkolonie/big/18": 312,
	"./pic/brodno/gallery/2022/polkolonie/big/18.webp": 312,
	"./pic/brodno/gallery/2022/polkolonie/big/2": 313,
	"./pic/brodno/gallery/2022/polkolonie/big/2.webp": 313,
	"./pic/brodno/gallery/2022/polkolonie/big/3": 314,
	"./pic/brodno/gallery/2022/polkolonie/big/3.webp": 314,
	"./pic/brodno/gallery/2022/polkolonie/big/4": 315,
	"./pic/brodno/gallery/2022/polkolonie/big/4.webp": 315,
	"./pic/brodno/gallery/2022/polkolonie/big/5": 316,
	"./pic/brodno/gallery/2022/polkolonie/big/5.webp": 316,
	"./pic/brodno/gallery/2022/polkolonie/big/6": 317,
	"./pic/brodno/gallery/2022/polkolonie/big/6.webp": 317,
	"./pic/brodno/gallery/2022/polkolonie/big/7": 318,
	"./pic/brodno/gallery/2022/polkolonie/big/7.webp": 318,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/1": 319,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/1.webp": 319,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/12": 320,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/12.webp": 320,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/18": 321,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/18.webp": 321,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/2": 322,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/2.webp": 322,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/3": 323,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/3.webp": 323,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/4": 324,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/4.webp": 324,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/5": 325,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/5.webp": 325,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/6": 326,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/6.webp": 326,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/7": 327,
	"./pic/brodno/gallery/2022/polkolonie/thumbs/7.webp": 327,
	"./pic/brodno/hero": 0,
	"./pic/brodno/hero-adults": 328,
	"./pic/brodno/hero-adults.svg": 328,
	"./pic/brodno/hero-career": 329,
	"./pic/brodno/hero-career.png": 329,
	"./pic/brodno/hero-contact-brodno-small": 330,
	"./pic/brodno/hero-contact-brodno-small.png": 330,
	"./pic/brodno/hero-how-we-teach": 18,
	"./pic/brodno/hero-how-we-teach.png": 18,
	"./pic/brodno/hero-how-we-teach.webp": 455,
	"./pic/brodno/hero-individual": 19,
	"./pic/brodno/hero-individual.png": 19,
	"./pic/brodno/hero-individual.webp": 456,
	"./pic/brodno/hero-kids": 1,
	"./pic/brodno/hero-kids.png": 1,
	"./pic/brodno/hero-kids.svg": 457,
	"./pic/brodno/hero-kids.webp": 458,
	"./pic/brodno/hero-teenagers": 331,
	"./pic/brodno/hero-teenagers.svg": 331,
	"./pic/brodno/hero.jpg": 459,
	"./pic/brodno/hero.png": 0,
	"./pic/brodno/hero.svg": 460,
	"./pic/brodno/hero.webp": 461,
	"./pic/brodno/hero_arrow_down": 20,
	"./pic/brodno/hero_arrow_down.png": 20,
	"./pic/brodno/hero_arrow_down.svg": 462,
	"./pic/brodno/hero_arrow_down_bg": 332,
	"./pic/brodno/hero_arrow_down_bg.png": 332,
	"./pic/brodno/hero_bg": 333,
	"./pic/brodno/hero_bg.png": 333,
	"./pic/brodno/hero_brodno_adults": 334,
	"./pic/brodno/hero_brodno_adults.svg": 334,
	"./pic/brodno/hero_brodno_kids": 335,
	"./pic/brodno/hero_brodno_kids.svg": 335,
	"./pic/brodno/hero_brodno_teenagers": 336,
	"./pic/brodno/hero_brodno_teenagers.svg": 336,
	"./pic/brodno/hero_contact_brodno": 21,
	"./pic/brodno/hero_contact_brodno.png": 21,
	"./pic/brodno/hero_contact_brodno.webp": 463,
	"./pic/brodno/hero_landscape": 22,
	"./pic/brodno/hero_landscape.png": 22,
	"./pic/brodno/hero_landscape.svg": 464,
	"./pic/brodno/hero_landscape_bg": 337,
	"./pic/brodno/hero_landscape_bg.png": 337,
	"./pic/brodno/join-us": 23,
	"./pic/brodno/join-us.jpg": 23,
	"./pic/brodno/join-us.webp": 465,
	"./pic/brodno/kamila-bandurska": 338,
	"./pic/brodno/kamila-bandurska.png": 338,
	"./pic/brodno/lektorzy": 339,
	"./pic/brodno/lektorzy.png": 339,
	"./pic/brodno/not_just_courses": 24,
	"./pic/brodno/not_just_courses.png": 24,
	"./pic/brodno/not_just_courses.svg": 466,
	"./pic/brodno/not_just_courses_bg": 340,
	"./pic/brodno/not_just_courses_bg.png": 340,
	"./pic/brodno/offer/equipment": 341,
	"./pic/brodno/offer/equipment.jpg": 341,
	"./pic/brodno/offer/map": 342,
	"./pic/brodno/offer/map.jpg": 342,
	"./pic/brodno/offer/team": 343,
	"./pic/brodno/offer/team.jpg": 343,
	"./pic/brodno/offer/trainers": 344,
	"./pic/brodno/offer/trainers.jpg": 344,
	"./pic/brodno/online_lessons": 25,
	"./pic/brodno/online_lessons.png": 25,
	"./pic/brodno/online_lessons.svg": 467,
	"./pic/brodno/online_lessons_bg": 345,
	"./pic/brodno/online_lessons_bg.png": 345,
	"./pic/brodno/people/kasia": 26,
	"./pic/brodno/people/kasia.png": 26,
	"./pic/brodno/people/kasia.webp": 468,
	"./pic/brodno/people/marika": 27,
	"./pic/brodno/people/marika.png": 27,
	"./pic/brodno/people/marika.webp": 469,
	"./pic/brodno/polygon_news_bigger": 28,
	"./pic/brodno/polygon_news_bigger.png": 28,
	"./pic/brodno/polygon_news_bigger.svg": 470,
	"./pic/brodno/polygon_news_bigger_bg": 346,
	"./pic/brodno/polygon_news_bigger_bg.png": 346,
	"./pic/brodno/polygon_news_smaller": 29,
	"./pic/brodno/polygon_news_smaller.png": 29,
	"./pic/brodno/polygon_news_smaller.svg": 471,
	"./pic/brodno/polygon_news_smaller_bg": 347,
	"./pic/brodno/polygon_news_smaller_bg.png": 347,
	"./pic/brodno/savvy-ed": 30,
	"./pic/brodno/savvy-ed.png": 30,
	"./pic/brodno/savvy-ed.webp": 472,
	"./pic/brodno/speaking": 31,
	"./pic/brodno/speaking.png": 31,
	"./pic/brodno/speaking.svg": 473,
	"./pic/brodno/speaking_bg": 348,
	"./pic/brodno/speaking_bg.png": 348,
	"./pic/brodno/team": 349,
	"./pic/brodno/team-hero": 32,
	"./pic/brodno/team-hero.jpg": 32,
	"./pic/brodno/team-hero.webp": 474,
	"./pic/brodno/team.jpg": 349,
	"./pic/brodno/team/administrative/jacek-czlonkowski": 33,
	"./pic/brodno/team/administrative/jacek-czlonkowski.png": 33,
	"./pic/brodno/team/administrative/jacek-czlonkowski.webp": 475,
	"./pic/brodno/team/administrative/joanna-rodak": 34,
	"./pic/brodno/team/administrative/joanna-rodak.png": 34,
	"./pic/brodno/team/administrative/joanna-rodak.webp": 476,
	"./pic/brodno/team/administrative/julia-gornicka": 350,
	"./pic/brodno/team/administrative/julia-gornicka.webp": 350,
	"./pic/brodno/team/administrative/karol-gulatowski": 35,
	"./pic/brodno/team/administrative/karol-gulatowski.png": 35,
	"./pic/brodno/team/administrative/karol-gulatowski.webp": 477,
	"./pic/brodno/team/administrative/karolina-dolecka": 351,
	"./pic/brodno/team/administrative/karolina-dolecka.png": 351,
	"./pic/brodno/team/administrative/katarzyna-dolecka": 36,
	"./pic/brodno/team/administrative/katarzyna-dolecka-saranda": 352,
	"./pic/brodno/team/administrative/katarzyna-dolecka-saranda.png": 352,
	"./pic/brodno/team/administrative/katarzyna-dolecka.png": 36,
	"./pic/brodno/team/administrative/katarzyna-dolecka.webp": 478,
	"./pic/brodno/team/administrative/katarzyna-drozdowska": 37,
	"./pic/brodno/team/administrative/katarzyna-drozdowska.png": 37,
	"./pic/brodno/team/administrative/katarzyna-drozdowska.webp": 479,
	"./pic/brodno/team/administrative/katarzyna-stelmach": 353,
	"./pic/brodno/team/administrative/katarzyna-stelmach.png": 353,
	"./pic/brodno/team/administrative/lucja-mysiorska": 354,
	"./pic/brodno/team/administrative/lucja-mysiorska.webp": 354,
	"./pic/brodno/team/administrative/maja-okulus": 355,
	"./pic/brodno/team/administrative/maja-okulus.png": 355,
	"./pic/brodno/team/administrative/marika-tarczynska": 38,
	"./pic/brodno/team/administrative/marika-tarczynska.png": 38,
	"./pic/brodno/team/administrative/marika-tarczynska.webp": 480,
	"./pic/brodno/team/administrative/martyna-stanczyk": 39,
	"./pic/brodno/team/administrative/martyna-stanczyk.png": 39,
	"./pic/brodno/team/administrative/martyna-stanczyk.webp": 481,
	"./pic/brodno/team/administrative/paulina-kropiewnicka": 356,
	"./pic/brodno/team/administrative/paulina-kropiewnicka.png": 356,
	"./pic/brodno/team/teachers/agata-szatecka": 40,
	"./pic/brodno/team/teachers/agata-szatecka.png": 40,
	"./pic/brodno/team/teachers/agata-szatecka.webp": 482,
	"./pic/brodno/team/teachers/beata-pyszkowska": 41,
	"./pic/brodno/team/teachers/beata-pyszkowska.png": 41,
	"./pic/brodno/team/teachers/beata-pyszkowska.webp": 483,
	"./pic/brodno/team/teachers/gabriel-neely": 42,
	"./pic/brodno/team/teachers/gabriel-neely.png": 42,
	"./pic/brodno/team/teachers/gabriel-neely.webp": 484,
	"./pic/brodno/team/teachers/gabriela-brzozowska": 43,
	"./pic/brodno/team/teachers/gabriela-brzozowska.png": 43,
	"./pic/brodno/team/teachers/gabriela-brzozowska.webp": 485,
	"./pic/brodno/team/teachers/izabela-kowalczyk": 44,
	"./pic/brodno/team/teachers/izabela-kowalczyk.png": 44,
	"./pic/brodno/team/teachers/izabela-kowalczyk.webp": 486,
	"./pic/brodno/team/teachers/izabela-sawa": 45,
	"./pic/brodno/team/teachers/izabela-sawa.png": 45,
	"./pic/brodno/team/teachers/izabela-sawa.webp": 487,
	"./pic/brodno/team/teachers/izabela-wadas": 46,
	"./pic/brodno/team/teachers/izabela-wadas.png": 46,
	"./pic/brodno/team/teachers/izabela-wadas.webp": 488,
	"./pic/brodno/team/teachers/jan-wagner": 47,
	"./pic/brodno/team/teachers/jan-wagner.png": 47,
	"./pic/brodno/team/teachers/jan-wagner.webp": 489,
	"./pic/brodno/team/teachers/justyna-kubiak": 48,
	"./pic/brodno/team/teachers/justyna-kubiak.png": 48,
	"./pic/brodno/team/teachers/justyna-kubiak.webp": 490,
	"./pic/brodno/team/teachers/kamila-bandurska": 49,
	"./pic/brodno/team/teachers/kamila-bandurska.png": 49,
	"./pic/brodno/team/teachers/kamila-bandurska.webp": 491,
	"./pic/brodno/team/teachers/karol-gulatowski": 357,
	"./pic/brodno/team/teachers/karol-gulatowski.webp": 357,
	"./pic/brodno/team/teachers/katarzyna-drozdowska": 358,
	"./pic/brodno/team/teachers/katarzyna-drozdowska.webp": 358,
	"./pic/brodno/team/teachers/kateryna-tkachenko": 50,
	"./pic/brodno/team/teachers/kateryna-tkachenko.png": 50,
	"./pic/brodno/team/teachers/kateryna-tkachenko.webp": 492,
	"./pic/brodno/team/teachers/konrad-knitter": 51,
	"./pic/brodno/team/teachers/konrad-knitter.png": 51,
	"./pic/brodno/team/teachers/konrad-knitter.webp": 493,
	"./pic/brodno/team/teachers/magdalena-roman": 52,
	"./pic/brodno/team/teachers/magdalena-roman.png": 52,
	"./pic/brodno/team/teachers/magdalena-roman.webp": 494,
	"./pic/brodno/team/teachers/malgorzata-lesinska": 53,
	"./pic/brodno/team/teachers/malgorzata-lesinska.png": 53,
	"./pic/brodno/team/teachers/malgorzata-lesinska.webp": 495,
	"./pic/brodno/team/teachers/maria-sarna": 54,
	"./pic/brodno/team/teachers/maria-sarna.png": 54,
	"./pic/brodno/team/teachers/maria-sarna.webp": 496,
	"./pic/brodno/team/teachers/marika-tarczynska": 359,
	"./pic/brodno/team/teachers/marika-tarczynska.webp": 359,
	"./pic/brodno/team/teachers/martyna-stanczyk": 55,
	"./pic/brodno/team/teachers/martyna-stanczyk.png": 55,
	"./pic/brodno/team/teachers/martyna-stanczyk.webp": 497,
	"./pic/brodno/team/teachers/michal-paszkowski": 56,
	"./pic/brodno/team/teachers/michal-paszkowski.png": 56,
	"./pic/brodno/team/teachers/michal-paszkowski.webp": 498,
	"./pic/brodno/team/teachers/natalia-sladewska": 57,
	"./pic/brodno/team/teachers/natalia-sladewska.png": 57,
	"./pic/brodno/team/teachers/natalia-sladewska.webp": 499,
	"./pic/brodno/team/teachers/natalia-targoni": 58,
	"./pic/brodno/team/teachers/natalia-targoni.png": 58,
	"./pic/brodno/team/teachers/natalia-targoni.webp": 500,
	"./pic/brodno/team/teachers/ola-najdecka": 59,
	"./pic/brodno/team/teachers/ola-najdecka.png": 59,
	"./pic/brodno/team/teachers/ola-najdecka.webp": 501,
	"./pic/brodno/team/teachers/oliwia-bernat": 60,
	"./pic/brodno/team/teachers/oliwia-bernat.png": 60,
	"./pic/brodno/team/teachers/oliwia-bernat.webp": 502,
	"./pic/brodno/team/teachers/paula-czyz": 61,
	"./pic/brodno/team/teachers/paula-czyz.png": 61,
	"./pic/brodno/team/teachers/paula-czyz.webp": 503,
	"./pic/brodno/team/teachers/paulina-kozlowska": 62,
	"./pic/brodno/team/teachers/paulina-kozlowska.png": 62,
	"./pic/brodno/team/teachers/paulina-kozlowska.webp": 504,
	"./pic/brodno/team/teachers/weronika-piwowarska": 63,
	"./pic/brodno/team/teachers/weronika-piwowarska.png": 63,
	"./pic/brodno/team/teachers/weronika-piwowarska.webp": 505,
	"./pic/brodno/team/teachers/wiktoria-tulodziecka": 64,
	"./pic/brodno/team/teachers/wiktoria-tulodziecka.png": 64,
	"./pic/brodno/team/teachers/wiktoria-tulodziecka.webp": 506,
	"./pic/brodno/teddy": 65,
	"./pic/brodno/teddy-eddie": 66,
	"./pic/brodno/teddy-eddie-big": 360,
	"./pic/brodno/teddy-eddie-big.svg": 360,
	"./pic/brodno/teddy-eddie.png": 66,
	"./pic/brodno/teddy-eddie.webp": 507,
	"./pic/brodno/teddy-small": 361,
	"./pic/brodno/teddy-small.webp": 361,
	"./pic/brodno/teddy-teacher": 67,
	"./pic/brodno/teddy-teacher.png": 67,
	"./pic/brodno/teddy-teacher.webp": 508,
	"./pic/brodno/teddy.png": 65,
	"./pic/brodno/teddy.svg": 509,
	"./pic/brodno/teddy_bg": 362,
	"./pic/brodno/teddy_bg.png": 362,
	"./pic/brodno/teddy_logo": 363,
	"./pic/brodno/teddy_logo.svg": 363,
	"./pic/brodno/teenagers": 364,
	"./pic/brodno/teenagers.svg": 364,
	"./pic/brodno/test_lessons": 68,
	"./pic/brodno/test_lessons.png": 68,
	"./pic/brodno/test_lessons.svg": 510,
	"./pic/brodno/test_lessons_bg": 365,
	"./pic/brodno/test_lessons_bg.png": 365,
	"./pic/brodno/video": 366,
	"./pic/brodno/video-shadow": 367,
	"./pic/brodno/video-shadow.png": 367,
	"./pic/brodno/video.png": 366,
	"./pic/brodno_building": 368,
	"./pic/brodno_building.svg": 368,
	"./pic/cake": 369,
	"./pic/cake.svg": 369,
	"./pic/cal": 370,
	"./pic/cal.svg": 370,
	"./pic/calendar": 371,
	"./pic/calendar.svg": 371,
	"./pic/communication_green": 372,
	"./pic/communication_green.svg": 372,
	"./pic/contact-bg": 373,
	"./pic/contact-bg.png": 373,
	"./pic/continuing_number": 374,
	"./pic/continuing_number.svg": 374,
	"./pic/courses_companies_orange": 375,
	"./pic/courses_companies_orange.svg": 375,
	"./pic/for_who": 376,
	"./pic/for_who.svg": 376,
	"./pic/form_orange": 377,
	"./pic/form_orange.svg": 377,
	"./pic/future_sight": 378,
	"./pic/future_sight.svg": 378,
	"./pic/future_sight_orange": 379,
	"./pic/future_sight_orange.svg": 379,
	"./pic/green-pin": 380,
	"./pic/green-pin.svg": 380,
	"./pic/helpfull_lectors": 381,
	"./pic/helpfull_lectors.svg": 381,
	"./pic/hero": 2,
	"./pic/hero.png": 2,
	"./pic/hero.svg": 511,
	"./pic/hero.webp": 512,
	"./pic/hero/bialoleka": 382,
	"./pic/hero/bialoleka.png": 382,
	"./pic/hero/brodno": 69,
	"./pic/hero/brodno.png": 69,
	"./pic/hero/brodno.webp": 513,
	"./pic/hero/buildings": 70,
	"./pic/hero/buildings.png": 70,
	"./pic/hero/buildings.webp": 514,
	"./pic/hero/flowers": 71,
	"./pic/hero/flowers.png": 71,
	"./pic/hero/flowers.webp": 515,
	"./pic/hero/lion": 72,
	"./pic/hero/lion.png": 72,
	"./pic/hero/lion.webp": 516,
	"./pic/hero/saska-kepa": 73,
	"./pic/hero/saska-kepa.png": 73,
	"./pic/hero/saska-kepa.webp": 517,
	"./pic/hero/sign": 74,
	"./pic/hero/sign.png": 74,
	"./pic/hero/sign.webp": 518,
	"./pic/hero/sun": 75,
	"./pic/hero/sun.png": 75,
	"./pic/hero/sun.webp": 519,
	"./pic/hero/woman": 76,
	"./pic/hero/woman.png": 76,
	"./pic/hero/woman.webp": 520,
	"./pic/home_hero": 383,
	"./pic/home_hero.svg": 383,
	"./pic/how_we_teach": 384,
	"./pic/how_we_teach.svg": 384,
	"./pic/intensivity_companies": 385,
	"./pic/intensivity_companies.svg": 385,
	"./pic/karol-gulatowski": 386,
	"./pic/karol-gulatowski.png": 386,
	"./pic/kids": 3,
	"./pic/kids.png": 3,
	"./pic/kids.svg": 521,
	"./pic/kids.webp": 522,
	"./pic/materials": 387,
	"./pic/materials.svg": 387,
	"./pic/materials_green": 388,
	"./pic/materials_green.svg": 388,
	"./pic/new_methods": 389,
	"./pic/new_methods.svg": 389,
	"./pic/orange-pin": 390,
	"./pic/orange-pin.svg": 390,
	"./pic/organization": 391,
	"./pic/organization.svg": 391,
	"./pic/organization_pale": 392,
	"./pic/organization_pale.svg": 392,
	"./pic/picaro": 393,
	"./pic/picaro.svg": 393,
	"./pic/podskakujaca-dziewczynka": 394,
	"./pic/podskakujaca-dziewczynka.webp": 394,
	"./pic/polygon-camps-big": 395,
	"./pic/polygon-camps-big.svg": 395,
	"./pic/polygon-camps-small": 396,
	"./pic/polygon-camps-small.svg": 396,
	"./pic/practical_skills": 397,
	"./pic/practical_skills.svg": 397,
	"./pic/raports": 398,
	"./pic/raports.svg": 398,
	"./pic/saska-contact-choice": 399,
	"./pic/saska-contact-choice.svg": 399,
	"./pic/saska/aska_hero_bg": 400,
	"./pic/saska/aska_hero_bg.png": 400,
	"./pic/saska/cambridge": 77,
	"./pic/saska/cambridge.png": 77,
	"./pic/saska/cambridge.svg": 523,
	"./pic/saska/cambridge_bg": 401,
	"./pic/saska/cambridge_bg.png": 401,
	"./pic/saska/elastic": 78,
	"./pic/saska/elastic.png": 78,
	"./pic/saska/elastic.svg": 524,
	"./pic/saska/elastic_bg": 402,
	"./pic/saska/elastic_bg.png": 402,
	"./pic/saska/exam": 403,
	"./pic/saska/exam.svg": 403,
	"./pic/saska/hero": 79,
	"./pic/saska/hero-adults": 404,
	"./pic/saska/hero-adults.svg": 404,
	"./pic/saska/hero-contact-saska-small": 405,
	"./pic/saska/hero-contact-saska-small.png": 405,
	"./pic/saska/hero-individual": 80,
	"./pic/saska/hero-individual.png": 80,
	"./pic/saska/hero-individual.webp": 525,
	"./pic/saska/hero-kids": 4,
	"./pic/saska/hero-kids.png": 4,
	"./pic/saska/hero-kids.svg": 526,
	"./pic/saska/hero-kids.webp": 527,
	"./pic/saska/hero-teenagers": 406,
	"./pic/saska/hero-teenagers.svg": 406,
	"./pic/saska/hero.jpg": 79,
	"./pic/saska/hero.webp": 528,
	"./pic/saska/hero_contact_saska": 407,
	"./pic/saska/hero_contact_saska.png": 407,
	"./pic/saska/hero_saska_adults": 81,
	"./pic/saska/hero_saska_adults.png": 81,
	"./pic/saska/hero_saska_adults.svg": 529,
	"./pic/saska/hero_saska_kids": 408,
	"./pic/saska/hero_saska_kids.svg": 408,
	"./pic/saska/hero_saska_teen": 409,
	"./pic/saska/hero_saska_teen.svg": 409,
	"./pic/saska/join-us": 410,
	"./pic/saska/join-us.jpg": 410,
	"./pic/saska/languages_companies_saska_background": 411,
	"./pic/saska/languages_companies_saska_background.svg": 411,
	"./pic/saska/online_lessons": 82,
	"./pic/saska/online_lessons.png": 82,
	"./pic/saska/online_lessons.svg": 530,
	"./pic/saska/online_lessons_bg": 412,
	"./pic/saska/online_lessons_bg.png": 412,
	"./pic/saska/polygon_news_bigger": 83,
	"./pic/saska/polygon_news_bigger.png": 83,
	"./pic/saska/polygon_news_bigger.svg": 531,
	"./pic/saska/polygon_news_bigger_bg": 413,
	"./pic/saska/polygon_news_bigger_bg.png": 413,
	"./pic/saska/polygon_news_smaller": 84,
	"./pic/saska/polygon_news_smaller.png": 84,
	"./pic/saska/polygon_news_smaller.svg": 532,
	"./pic/saska/polygon_news_smaller_bg": 414,
	"./pic/saska/polygon_news_smaller_bg.png": 414,
	"./pic/saska/saska_adults": 85,
	"./pic/saska/saska_adults.png": 85,
	"./pic/saska/saska_adults.svg": 533,
	"./pic/saska/saska_adults_bg": 415,
	"./pic/saska/saska_adults_bg.png": 415,
	"./pic/saska/saska_headmaster": 416,
	"./pic/saska/saska_headmaster.svg": 416,
	"./pic/saska/saska_hero": 417,
	"./pic/saska/saska_hero.svg": 417,
	"./pic/saska/saska_kids": 86,
	"./pic/saska/saska_kids.png": 86,
	"./pic/saska/saska_kids.svg": 534,
	"./pic/saska/saska_kids_bg": 418,
	"./pic/saska/saska_kids_bg.png": 418,
	"./pic/saska/saska_news": 5,
	"./pic/saska/saska_news.png": 5,
	"./pic/saska/saska_news.svg": 535,
	"./pic/saska/saska_news.webp": 536,
	"./pic/saska/saska_news_bg": 419,
	"./pic/saska/saska_news_bg.png": 419,
	"./pic/saska/saska_teenagers": 87,
	"./pic/saska/saska_teenagers.png": 87,
	"./pic/saska/saska_teenagers.svg": 537,
	"./pic/saska/saska_teenagers_bg": 420,
	"./pic/saska/saska_teenagers_bg.png": 420,
	"./pic/saska/speaking": 88,
	"./pic/saska/speaking.png": 88,
	"./pic/saska/speaking.svg": 538,
	"./pic/saska/speaking_bg": 421,
	"./pic/saska/speaking_bg.png": 421,
	"./pic/saska/team-hero": 422,
	"./pic/saska/team-hero.jpg": 422,
	"./pic/saska/team/teachers/aleksandra-maslankiewicz": 89,
	"./pic/saska/team/teachers/aleksandra-maslankiewicz.png": 89,
	"./pic/saska/team/teachers/aleksandra-maslankiewicz.webp": 539,
	"./pic/saska/team/teachers/aneta-dunn": 90,
	"./pic/saska/team/teachers/aneta-dunn.png": 90,
	"./pic/saska/team/teachers/aneta-dunn.webp": 540,
	"./pic/saska/team/teachers/anna-adamczyk-rucel": 91,
	"./pic/saska/team/teachers/anna-adamczyk-rucel.png": 91,
	"./pic/saska/team/teachers/anna-adamczyk-rucel.webp": 541,
	"./pic/saska/team/teachers/anna-dabrowska": 92,
	"./pic/saska/team/teachers/anna-dabrowska.png": 92,
	"./pic/saska/team/teachers/anna-dabrowska.webp": 542,
	"./pic/saska/team/teachers/anna-potworowska-pluciennik": 93,
	"./pic/saska/team/teachers/anna-potworowska-pluciennik.png": 93,
	"./pic/saska/team/teachers/anna-potworowska-pluciennik.webp": 543,
	"./pic/saska/team/teachers/julita-nowik-grodek": 94,
	"./pic/saska/team/teachers/julita-nowik-grodek.png": 94,
	"./pic/saska/team/teachers/julita-nowik-grodek.webp": 544,
	"./pic/saska/team/teachers/mario-cordova": 95,
	"./pic/saska/team/teachers/mario-cordova.png": 95,
	"./pic/saska/team/teachers/mario-cordova.webp": 545,
	"./pic/saska/team/teachers/piotr-zysik": 96,
	"./pic/saska/team/teachers/piotr-zysik.png": 96,
	"./pic/saska/team/teachers/piotr-zysik.webp": 546,
	"./pic/saska/team/teachers/sonja-gorniak": 97,
	"./pic/saska/team/teachers/sonja-gorniak.png": 97,
	"./pic/saska/team/teachers/sonja-gorniak.webp": 547,
	"./pic/saska/team/teachers/ula-parfienowicz": 98,
	"./pic/saska/team/teachers/ula-parfienowicz.png": 98,
	"./pic/saska/team/teachers/ula-parfienowicz.webp": 548,
	"./pic/saska/teddy": 99,
	"./pic/saska/teddy.png": 99,
	"./pic/saska/teddy.svg": 549,
	"./pic/saska/teddy_bg": 423,
	"./pic/saska/teddy_bg.png": 423,
	"./pic/saska/test_lessons": 100,
	"./pic/saska/test_lessons.png": 100,
	"./pic/saska/test_lessons.svg": 550,
	"./pic/saska/test_lessons_bg": 424,
	"./pic/saska/test_lessons_bg.png": 424,
	"./pic/saska_building": 425,
	"./pic/saska_building.svg": 425,
	"./pic/special_courses": 426,
	"./pic/special_courses.svg": 426,
	"./pic/students_number": 427,
	"./pic/students_number.svg": 427,
	"./pic/teachers_number": 428,
	"./pic/teachers_number.svg": 428,
	"./pic/team": 6,
	"./pic/team.png": 6,
	"./pic/team.svg": 551,
	"./pic/team.webp": 552,
	"./pic/zadowolone-dzieci": 101,
	"./pic/zadowolone-dzieci.png": 101,
	"./pic/zadowolone-dzieci.webp": 553,
	"./touch/app-icon": 429,
	"./touch/app-icon.png": 429,
	"./touch/homescreen144": 430,
	"./touch/homescreen144.png": 430,
	"./touch/homescreen168": 431,
	"./touch/homescreen168.png": 431,
	"./touch/homescreen192": 432,
	"./touch/homescreen192.png": 432,
	"./touch/homescreen48": 433,
	"./touch/homescreen48.png": 433,
	"./touch/homescreen72": 434,
	"./touch/homescreen72.png": 434,
	"./touch/homescreen96": 435,
	"./touch/homescreen96.png": 435,
	"./touch/splash-screen": 436,
	"./touch/splash-screen.png": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;